import NewsletterFormExt from '_core_ext/components/forms/NewsletterForm';

export default class NewsletterForm extends NewsletterFormExt {
    init() {
        super.init();

        this.event('change', '.showStatusIcon', this.showStatusIcon);
        this.event('change', '.js-notifyme-acceptlettersubscription', this.acceptNewsletter);
        this.event('blur', '.js-newsletter-email input[type=email]', this.newsletterEmailErrors);
        this.event('change', '.show-read-more-newsletterlanding .js-newsletter-policy', this.updateSubscribeButton);
        this.expandReadMore();
    }

    expandReadMore() {
        var showReadMoreFooterBlock =  $('.show-read-more-footer .form-row_label.js-input-label');
        if (showReadMoreFooterBlock) {
            var readMoreseo = Resources.VIEWMORE;
            var readLessseo = Resources.VIEWLESS;
            let $readMoreFooterBlock = $('.read-more-footer');
            if(!$readMoreFooterBlock.length){
            $('<a href="javascript:void(0);" class="read-more-footer"><span class="read-more-text-footer">' + readMoreseo + '</span></a>').insertAfter($(showReadMoreFooterBlock));
            var showReadMoreFooter = $(".show-read-more-footer");
            var readMoreFooter = $(".read-more-footer");
            var readMoreTextFooter = readMoreFooter.find('.read-more-text-footer');
            readMoreFooter.click(function () {
                    if(!readMoreFooter.hasClass('read-less')){
                        readMoreTextFooter.text(readLessseo);
                        $(readMoreFooter).addClass('read-less');
                        $(showReadMoreFooter).addClass('read-less');
                    }else{
                        readMoreTextFooter.text(readMoreseo);
                        $(readMoreFooter).removeClass('read-less');
                        $(showReadMoreFooter).removeClass('read-less');
                    }
                });
            }    
        }
    }

    newsletterEmailErrors(){
        let newsletterEmailFailure = $('.js-newsletter-email .subscriptionfailure');
        if(newsletterEmailFailure.length > 0){
            newsletterEmailFailure.remove();
            $('.js-newsletter-email .form-row_field .error-icon').css('display', 'none');
        }
    }

    showStatusIcon(el, event) {
        $(event.target).siblings('.success-icon, .error-icon').hide();
        if (!$(event.target).valid()) {
            $(event.target).siblings('.error-icon').show();
        } else {
            $(event.target).siblings('.success-icon').show();
        }
    }
    acceptNewsletter(el, event) {

        if ($('.js-notifyme-acceptlettersubscription').is(':checked')) {
            //console.log("Checked");
        }else{
            //cosnole.log("unchecked");
        }
        
    }

    updateSubscribeButton(){
        let newsletterPolicy = $('.show-read-more-newsletterlanding .js-newsletter-policy').is(':checked');
        if(newsletterPolicy){
            $('.c-subscribe-form__btn').removeClass('disabled');
        }else{
            $('.c-subscribe-form__btn').addClass('disabled');
        }
    }



    onSubmitSuccess(result) {
        this.$el.trigger('newsletterSubscription.success', [this.$el]);
        $('#header-top-banner, #header-bottom-banner, .js-header-nav-container, .header__menu-utility, .js-menu-tab-content').removeClass('d-none');
        $('#logo').removeClass('logo-space');
        this.$el.find('.js-emailform-wrapper').hide();
        this.$el.find('.redbull-form').hide();
        this.$el.find('.js-toggle_content').hide();
        if(result.displayDoubleOptinMessage){
            this.$el.find('.msg-with-email-icon i.mail-icon').fadeIn();
            this.$el.find('.js-result_message-double-optin').fadeIn();
        }else {
            this.$el.find('.msg-with-check-icon i.check-icon').fadeIn();
            this.$el.find('.js-result_message-not-double-optin').fadeIn();
        }
        this.$el.find('.js-result_message').fadeIn();
        this.$el.find('.js-result_message').parents('.c-account__content').addClass('user-subscribed');
        this.$el.find('.js-result_message').parents('.c-account__content').find('.c-subscribe-form__subscribed-msg').hide();
        this.$el.get(0).reset();
    }
}